export default "__VITE_ASSET__DCG0cIP9__"